import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router';

import { RouteGuard } from '../authz/RouteGuard';
import { ISADMINLOGGED } from '../constants/global';
import { pageurl } from '../constants/pageurl';
import Layout from '../layout';

export interface IRouteProps {
	path?: string | string[] | undefined;
}

const AdminRoute: FC<IRouteProps> = () => {
	if (!ISADMINLOGGED()) {
		return <Navigate to={pageurl.LOGIN} />;
	}
	// The guard sits INSIDE the layout so a denial keeps the sidebar and header — a
	// dead-end page is no help to someone who followed a link they can't open.
	return (
		<Layout adminRoute>
			<RouteGuard>
				<Outlet />
			</RouteGuard>
		</Layout>
	);
};

export default AdminRoute;
